import { ReactNode } from "react";
import HeaderComponent from "../../features/header-component/HeaderComponentV2";
import { Stack } from "@mui/material";
import classes from "./MainLayout.module.scss";

interface PatientMainLayoutProps {
  children: ReactNode;
}

const PatientMainLayout: React.FC<PatientMainLayoutProps> = ({ children }) => {
  return (
    <div>
      <HeaderComponent />
      <Stack spacing={2} className={classes.content}>
        {children}
      </Stack>
    </div>
  );
};

export default PatientMainLayout;
